const BASE_URL = process.env.REACT_APP_API_URL;

// AUTH ENDPOINTS
export const endpoints = {
    SIGNUP_API: BASE_URL + "/auth/signup",
    EMPLOYEESIGNUP_API: BASE_URL + "/auth/employee-signup",
    LOGIN_API: BASE_URL + "/auth/login",
    RESETPASSTOKEN_API: BASE_URL + "/auth/reset-password-token",
    RESETPASSWORD_API: BASE_URL + "/auth/reset-password",
  };


  // SETTINGS PAGE API
export const settingsEndpoints = {
    UPDATE_DISPLAY_PICTURE_API: BASE_URL + "/profile/updateDisplayPicture",
    UPLOAD_PICTURE_API: BASE_URL + "/profile/uploadPicture",
    UPDATE_PROFILE_API: BASE_URL + "/profile/updateProfile",
    CHANGE_PASSWORD_API: BASE_URL + "/auth/changepassword",
    DELETE_PROFILE_API: BASE_URL + "/profile/deleteProfile",
  };

  // PROFILE ENDPOINTS
export const profileEndpoints = {
    GET_USER_DETAILS_API: BASE_URL + "/profile/getUserDetails",
    GET_USER_ENROLLED_NODES_API: BASE_URL + "/profile/getNodes",
    ADMIN_DASHBOARD_API: BASE_URL + "/profile/adminDashboard",
  };

  export const adminEndpoints = {
    CREATE_EMPLOYEE_INVITE_API: `${BASE_URL}/admin/invite`,
    GET_INVITED_EMPLOYEES_API: `${BASE_URL}/admin/get-invited-employees`,
    REMOVE_EMPLOYEE_API: (employeeId) => `${BASE_URL}/admin/remove-employee/${employeeId}`,
    
  };

  // template endpoints
  export const templateEndpoints = {
    CREATE_TEMPLATE_API: BASE_URL + "/templates",
    GET_TEMPLATES_API: BASE_URL +"/templates",
    DELETE_TEMPLATE_API: BASE_URL +"/templates", // you'll pass ID in URL later
  };
  